export enum OrderStatus {
  CREATED = 'CREATED',

  ASSIGNED = 'ASSIGNED',

  IN_PROGRESS = 'IN_PROGRESS',

  FINISHED = 'FINISHED',

  DELIVERED = 'DELIVERED',

  CLOSED = 'CLOSED',

  CANCELLED = 'CANCELLED',

  ACCEPTED = 'ACCEPTED',

  REJECTED = 'REJECTED',

  IN_TRANSIT = 'IN_TRANSIT',
}
